import React from "react";
import { Box } from "@material-ui/core";
import { CustomCard } from "../../CustomCard";
import Skeleton from "@material-ui/lab/Skeleton";

// Styles
import useStyles from "./styles";

function CompleteProfileImagesSkeleton() {
  const styles = useStyles();
  return (
    <CustomCard className={styles.cardStyle}>
      <Box className={styles.mainContainer}>
        <Skeleton variant="rect" className={styles.imageBox} animation="wave" />
        <Box className={styles.detailsContainer}>
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="rect" width={60} height={20} />
        </Box>
      </Box>
    </CustomCard>
  );
}

export default CompleteProfileImagesSkeleton;
